import React from 'react';
import ContentSection from '../ContentSection';
import RadioGroup from '../RadioGroup';
import RadioButton from '../RadioButton';
import Moment from 'moment';
import SelectBox from '../SelectBox';
import {linkState} from '../../helpers/react-helpers';
import {GridCol, GridRow} from '../grid-form';
import SaveSubmitButton from '../SaveSubmitButton';
// import {postJson} from '../../helpers/ajax';
import kb from '../../kb';
import AioDatePicker from '../aio-inputs/AioDatePicker';
import {pick} from 'lodash';
import ButtonRow from "../ButtonRow";
import {resolveRoute} from '../../helpers/ajax'

const now = Moment();
const DATE_FORMAT = 'YYYY-MM-DD';

type State = any;

export default class FinancialSummaryReport extends React.Component<{}, State> {


    constructor(props: any) {
        super(props);


        this.state = {
            dateType: 'MONTH',
            whichDate: 'CREATE',
            month: now.format('YYYY-MM'),
            start: now.clone().subtract(1, 'month').format(DATE_FORMAT),
            end: now.format(DATE_FORMAT),
        }
    }

    submit = (ev: any) => {
        ev.preventDefault();


        let postData;

        switch (this.state.dateType) {
            case 'MONTH':
                postData = pick(this.state, ['dateType', 'whichDate', 'month']);
                break;
            case 'DATE_RANGE':
                postData = pick(this.state, ['dateType', 'whichDate', 'start', 'end']);
                break;
            default:
                throw new Error(`Invalid date type: ${this.state.dateType}`)
        }


        kb.navigate(resolveRoute('reports.downloadFinancialSummary', postData));
    }


    render() {
        const monthIter = Moment()
        const months = [];
        const numMonths = 36;

        const startDateOptions: Partial<React.ComponentPropsWithoutRef<typeof AioDatePicker>> = {}
        const endDateOptions: Partial<React.ComponentPropsWithoutRef<typeof AioDatePicker>> = {}

        switch (this.state.whichDate) {
            case 'CREATE':
                startDateOptions.maxDate = Moment.min(now, Moment(this.state.end, DATE_FORMAT)).toDate();
                endDateOptions.minDate = Moment(this.state.start, DATE_FORMAT).toDate();
                endDateOptions.maxDate = now.toDate();
                break;
            case 'PICKUP':
                startDateOptions.maxDate = Moment(this.state.end, DATE_FORMAT).toDate();
                endDateOptions.minDate = Moment(this.state.start, DATE_FORMAT).toDate();
                monthIter.add(12, 'months');
                break;
        }

        for (let i = 0; i < numMonths; ++i) {
            months.push({
                label: monthIter.format('MMMM YYYY'),
                value: monthIter.format('YYYY-MM')
            });
            monthIter.subtract(1, 'month');
        }

        return (
            <ContentSection title="Financial Summary" className="no-scroll">
                <p>Generate a spreadsheet containing all billing details for bookings within the selected date
                    range.</p>

                <form className="grid-form" onSubmit={this.submit}>
                    <GridRow>
                        <GridCol>
                            <label>Search by which date?</label>
                            <RadioGroup {...linkState.call(this, 'whichDate')}>
                                <RadioButton value="CREATE">Booking Created</RadioButton>
                                <RadioButton value="PICKUP">First Pickup</RadioButton>
                            </RadioGroup>
                        </GridCol>
                    </GridRow>

                    <GridRow>
                        <GridCol>
                            <label>What period?</label>
                            <RadioGroup {...linkState.call(this, 'dateType')}>
                                <RadioButton value="MONTH">Month</RadioButton>
                                <RadioButton value="DATE_RANGE">Date Range</RadioButton>
                            </RadioGroup>
                        </GridCol>
                    </GridRow>

                    {this.state.dateType === 'MONTH' && <GridRow><GridCol>
                        <SelectBox className="auto-width" {...linkState.call(this, 'month')}>
                            {months.map(mo => (
                                <option key={mo.value} value={mo.value}>{mo.label}</option>
                            ))}
                        </SelectBox>
                    </GridCol>
                    </GridRow>}

                    {this.state.dateType === 'DATE_RANGE' && <GridRow><GridCol>
                        <AioDatePicker label="Start Date" {...linkState.call(this, 'start', (date:string) => date)}
                                    {...startDateOptions} inline/> to <AioDatePicker label="End Date" {...linkState.call(this, 'end', (date:string)=>date)} {...endDateOptions} inline/>
                    </GridCol>
                    </GridRow>}


                    <ButtonRow>
                        <ButtonRow.Left>
                            <SaveSubmitButton>Download CSV</SaveSubmitButton>
                        </ButtonRow.Left>
                    </ButtonRow>
                </form>
            </ContentSection>
        )

    }
}
